import { NgComponentOutlet } from '@angular/common';
import { Component, input, Type } from '@angular/core';
import { SearchActivityItemComponent } from '@web/shared/components/search/items/search-activity-item.component';
import { SearchEntry } from '../types/search-entry.type';
import { SearchBidItemComponent } from './search-bid-item.component';
import { SearchConstructionSiteItemComponent } from './search-construction-site-item.component';
import { SearchContactItemComponent } from './search-contact-item.component';
import { SearchDocumentAssetItemComponent } from './search-document-asset-item.component';
import { SearchEmployeeItemComponent } from './search-employee-item.component';
import { SearchLeadItemComponent } from './search-lead-item.component';
import { SearchNoteItemComponent } from './search-note-item.component';
import { SearchProjectItemComponent } from './search-project-item.component';
import { SearchRealEstateItemComponent } from './search-real-estate-item.component';
import { SearchScoutingItemComponent } from './search-scouting-item.component';
import { SearchSupplierItemComponent } from './search-suppliers-item.component';
import { SearchTaskItemComponent } from './search-task-item.component';

@Component({
  selector: 'app-search-item',
  imports: [NgComponentOutlet],
  template: `@let _item = item();
    <ng-container *ngComponentOutlet="componentMap[_item.searchEntryKind]; inputs: { item: _item }"> </ng-container> `,
})
export class SearchItemComponent {
  readonly item = input.required<SearchEntry>();

  readonly componentMap: Record<SearchEntry['searchEntryKind'], Type<unknown>> = {
    contacts: SearchContactItemComponent,
    leads: SearchLeadItemComponent,
    scoutings: SearchScoutingItemComponent,
    bids: SearchBidItemComponent,
    notes: SearchNoteItemComponent,
    activities: SearchActivityItemComponent,
    'real-estates': SearchRealEstateItemComponent,
    projects: SearchProjectItemComponent,
    'construction-sites': SearchConstructionSiteItemComponent,
    tasks: SearchTaskItemComponent,
    employees: SearchEmployeeItemComponent,
    suppliers: SearchSupplierItemComponent,
    'document-assets': SearchDocumentAssetItemComponent,
  };
}
